import { Component, Inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { single } from 'rxjs';

export interface DeleteProjectModalData {
  isSingleProject: boolean;
  projects: string;
  chatCount: number;
}

export interface DeleteProjectModalResult {
  confirmed: boolean;
  deleteChats: boolean;
}

@Component({
  standalone: false,
  selector: 'app-deo-delete-project',
  templateUrl: './deo-delete-project.component.html',
  styleUrls: ['./deo-delete-project.component.scss']
})
export class DeoDeleteProjectComponent {
  projectName = '';
  isSingleProject = false;
  projects: any = '';
  chatCount = 0;
  typedProjectName = '';
  deleteChats = true;
  projectDeleteMsg = '';
  chatCountMsg = '';

  constructor(
    private readonly _modalRef: NzModalRef<DeoDeleteProjectComponent, DeleteProjectModalResult | undefined>,
    @Inject(NZ_MODAL_DATA) private readonly _modalData: DeleteProjectModalData
  ) {
    this.projects = this._modalData?.projects ?? '';
    this.isSingleProject = this._modalData?.isSingleProject ?? false;
    this.projectName = this.isSingleProject ? this.projects[0].name : `selected projects`;
    this.chatCount = this.isSingleProject ? (this.projects[0].chats ?? 0) : 0;
    if (this.isSingleProject) {
      this.projectDeleteMsg = `Are you sure you want to delete the project "${this.projectName}"?`;
      this.chatCountMsg = `Also delete all chats in this project (${this.chatCount} chats)`;
    } else {
      this.projectDeleteMsg = `Are you sure you want to delete the selected ${this.projects.length} projects?`;
      this.chatCountMsg = `Also delete all chats in these selected projects`;
    }
  }

  /** Enter is not a native checkbox key, so the model is flipped here. */
  onCheckboxKey(event: Event): void {
    event.preventDefault();
    this.deleteChats = !this.deleteChats;
  }

  get isDeleteDisabled(): boolean {
    if (this.isSingleProject) {
      return this.typedProjectName.trim() !== this.projectName;
    } else {
      return false;
    }
  }

  onCancel(): void {
    this._modalRef.destroy();
  }

  onDelete(): void {
    if (this.isDeleteDisabled) {
      return;
    }

    this._modalRef.close({
      confirmed: true,
      deleteChats: this.deleteChats
    });
  }
}
